module.exports = __webpack_public_path__ + "img/Armada Finance.9653654b.png";